<ng-container *ngIf="lazyComponent">
  @defer {
    <ng-container *ngComponentOutlet="lazyComponent; injector: customInjector" />
  }
</ng-container>
